export default "__VITE_ASSET__CmYPP9A4__"